import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // global offset
    offsetTop: 0,
    // reserve dialog states
    bReserve: false,
    // Global alerts
    sText: null,
    sAlertType: null,
    bAlert: false,
  },
  mutations: {
    toggleAlert (state, alert) {
      state.sText = alert.sText
      state.sAlertType = alert.sAlertType
      state.bAlert = true
    },
    setAlertState (state, value) {
      state.bAlert = value
    },
    // offsetTop mutation
    setOffsetTop (state, value) {
      state.offsetTop = value
    },
    // toggle reservation dialog
    setReservation (state, value) {
      state.bReserve = value
    }
  },
  actions: {

  }
})
